import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "@auth0/auth0-angular";
import {Router} from "@angular/router";
import {UserService} from "../../api";
import {REGISTRATION_URL} from "../registration-redirect/registration-redirect.component";

@Component({
  selector: 'login-page',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  form!: FormGroup;
  loginError: string | null = null;
  registrationUrl = REGISTRATION_URL;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private userService: UserService
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  ngOnInit() {
  }

  onLogin() {
    this.loginError = null;
    this.auth.loginWithPopup().subscribe({
      next: () => {
        this.auth.user$.subscribe(user => {
          if (user) {
            this.auth.getAccessTokenSilently().subscribe(() => {
              // Alt-Token aus Versionen vor DOCU-1323 entfernen; er wird nicht mehr gelesen.
              localStorage.removeItem("token");
              const redirectUrl = sessionStorage.getItem('redirectUrl') || '/audits';
              sessionStorage.removeItem('redirectUrl');
              this.router.navigateByUrl(redirectUrl);
            });
          }
        });
      },
      error: (err) => {
        if (err?.error === 'unauthorized' && err?.message === 'user is blocked') {
          this.router.navigate(['/user/blocked']);
          return;
        }
        // Popup vom User aktiv geschlossen → keine Fehlermeldung
        if (err?.error === 'cancelled' || err?.error === 'popup_closed_by_user') {
          return;
        }
        this.loginError =
          err?.error_description ?? err?.message ?? 'Anmeldung fehlgeschlagen.';
      }
    });
  }
}
